import AuthContext from '@xometry/auth-context';
import React, { useContext } from 'react';

function PrivateRoute({ component: Component, pageName, ...rest }) {
  const { user, isLoading } = useContext(AuthContext);

  window.analytics.page(pageName);

  if (isLoading) return <div />;

  if (user) return <Component {...rest} />;
  return <></>;
}

export default PrivateRoute;
